module.exports = __webpack_public_path__ + "assets/img/addImg.e1b8d33a.png";